import { get, post } from '@/api/general';

export default {
    contacts: () => get('chat/contacts'),
    chats: () => get('chat/dialogs'),
    sendMessage: (data) => post('chat/send/message', data),
};
